// extracted by mini-css-extract-plugin
export default {"iconWrapper":"bXNl6","icon":"EUvsZ"};